import { render, staticRenderFns } from "./orderRemark.vue?vue&type=template&id=0dcd86ff&scoped=true&"
import script from "./orderRemark.vue?vue&type=script&lang=js&"
export * from "./orderRemark.vue?vue&type=script&lang=js&"
import style0 from "./orderRemark.vue?vue&type=style&index=0&id=0dcd86ff&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcd86ff",
  null
  
)

export default component.exports